<template>
  <div class="my-4" v-if="emailsObject && emailsObject.has_emails">
    <div class="card text-left">
      <div class="card-body py-3">
        <h3 class="mb-3 t-500">
          {{ title }} <i v-if="tooltipText" class="fa fa-info-circle t-secondary t-xs" v-tooltip="tooltipText" />
        </h3>
        <!-- If emails is empty, prompt to contact sales -->
        <a
          v-if="isEmpty(emailsObject.emails)"
          href="https://www.academiclabs.com/contact-sales" target="_blank"
        >Contact us for the email add-on</a>
        <!-- Else show emails -->
        <div v-for="email in emailsObject.emails" :key="email.email">
          <i class="fa fa-envelope t-secondary t-xs pr-2" /><a class="t-overflow" :href="`mailto:${email.email}`" target="_blank">{{ email.email }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activeEmailAddress',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Active email address'
    },
    emailsObject: {
      type: Object,
      default: () => {},
      required: false
    }
  },
  computed: {
    tooltipText () {
      if (this.emailsObject.emails.length === 1) {
        return `Active email validity: ${this.emailsObject.emails[0].email_validity}`
      } else if (this.emailsObject.emails.length > 1) {
        const validityText = this.emailsObject.emails.map(email => {
          return `${email.email_validity} (${email.email})`
        }).join(', ')

        return `Active email validity: ${validityText}`
      }
      return ''
    }
  }
}
</script>
